import React from 'react';
import { Alert, Snackbar } from '@mui/material';

export default function ApprovalFeedbackSnackbar({ feedback, onClose }) {
    return (
        <Snackbar
            open={feedback.open}
            autoHideDuration={6000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={onClose} severity={feedback.severity} sx={{ width: '100%' }}>
                {feedback.message}
            </Alert>
        </Snackbar>
    );
}
